import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { getClientFromUrl, UNKNOWN_CLIENT_MESSAGE } from './utils';

@Injectable()
export class ClientInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add client  header
    const clientFromUrl = getClientFromUrl();
    if (!clientFromUrl) {
      // the app configuration is a static asset and must still load so the error can be displayed
      if (request.url.startsWith('assets/')) {
        return next.handle(request);
      }
      return throwError(() => new HttpErrorResponse({ error: { message: UNKNOWN_CLIENT_MESSAGE }, url: request.url }));
    }
    request = request.clone({
      setHeaders: {
        'clientname': clientFromUrl
      }
    });

    return next.handle(request);
  }
}
